import React, { useEffect, useRef } from "react";
import { stripHighlights } from "../helper/writingSelection";

const DescriptionEditor = ({ onChange, value, highlightHtml }) => {
  const editorRef = useRef(null);
  const lastValueRef = useRef("");
  const lastRenderedRef = useRef("");

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;
    // Never clobber the DOM while the user is typing.
    if (document.activeElement === editor) return;

    const clean = value || "";
    // Render highlights when provided, otherwise the plain value. Highlights
    // are visual-only — they're stripped on input so `value` stays clean.
    const toRender = highlightHtml || clean;
    if (lastRenderedRef.current === toRender && editor.innerHTML === toRender) return;

    editor.innerHTML = toRender;
    lastValueRef.current = clean;
    lastRenderedRef.current = toRender;
  }, [value, highlightHtml]);

  const handleInput = (event) => {
    const raw = event.currentTarget.innerHTML;
    // Strip highlight spans so the saved/reported content is always clean HTML.
    const clean = stripHighlights(raw);
    lastValueRef.current = clean;
    lastRenderedRef.current = raw;
    onChange && onChange(clean);
  };

  return (
    <div className="contant-editer">
      <div
        ref={editorRef}
        className="description-editor-local"
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-placeholder="Write or generate content here..."
      />
    </div>
  );
};

export default DescriptionEditor;
